import React, {useState, useEffect} from 'react';
import {IntlProvider} from 'react-intl';
import Cantonese from './zh.json';
import English from './en.json';
import US from './us.json';
export const Context = React.createContext({});
const local = navigator.language.split('-')[0];

let lang;
if (local==="zh") {
    lang = Cantonese;
} else if (local==="us") {
    lang = {...English, ...US};
} else {
    lang = English;
}
/**
 * https://lokalise.com/blog/react-i18n-intl/#Declaring_Messages
 * description is optional
 * id and defaultMessage are mandatory
 */


const Locale = props => {
    const [locale, setLocale] = useState(local);
    const [messages, setMessages] = useState(lang);

    useEffect(() => {
        if(props.locale) {
            let local = props.locale;
            setLocale(local);
            if (local==="zh") {
                lang = Cantonese;
            } else if (local==="us") {
                lang = {...English, ...US};
            } else {
                lang = English;
            }
            setMessages(lang)
        }
    });

    // eslint-disable-next-line
    function changeLanguage(e) {
        selectLanguage(e.target.value);
    }
    function selectLanguage(newLocale) {
        setLocale(newLocale);
        if (newLocale === 'en') {
            setMessages(English);
        } else {
            setMessages(Cantonese);
        }
    }
    return (
        <Context.Provider value = {{locale, selectLanguage}}>
            <IntlProvider messages={messages} locale={locale}>
                {props.children}
            </IntlProvider>
        </Context.Provider>
    );
}
export default Locale;
